import React from 'react';
import './Wrapper.css';

export const Wrapper = ({children}) => {
  return (
    <>
      <div className='wrapper'>
        {children}
      </div>
    </>
  )
}

export default Wrapper;
